const isProd = process.env.NODE_ENV === 'production';
// 是否测试环境
const isTestEnv = process.env.TESTING_PREFIX === 'offline';

const isPreEnv = process.env.TESTING_PREFIX === 'pre';
// 是否线上环境，用于区分测试环境
const isOnline = isProd && !isTestEnv && !isPreEnv;

const AXIOS_SERVER_HOST = 'test.hailvshi.cn';

// 浏览器host
const BROWSER_HOST = window.location.host;
// protocal
// 开发环境：后端port

const config = {
  host: 'localhost',
  port: 3300,
  isProd,
  name: 'merchant store',
  contextRoot: '',
  serviceHost: AXIOS_SERVER_HOST,
  servicePort: isOnline ? 443 : 80,
  servicePath: '',
  isOnline,
  SERVER_REMOT_TIMEOUT: 60000,
  BROWSER_HOST,
  commonAxiosProps: {
    xsrfCookieName: 'csrftoken',
    xsrfHeaderName: 'X-csrftoken',
  },
  oss: {
    bucket: isOnline ? 'distribution-shop-prod' : 'distribution-shop-test',
    endpoint: 'obs.cn-north-4.myhuaweicloud.com',
    access_key_id: 'HPUAVZUE2VME1A6VEJE2',
    secret_access_key: 's9YFTr2BOIzEL5qP3VGjOHGP9SAMB1ahWdOI8toq',
  },
};

export default config;
